export const IRIPrefix = '#';

export function IRIToId(IRI: string): string {
  if (IRI?.startsWith('nw:')) {
    return IRI.split('nw:')[1];
  }
  return IRI?.split(IRIPrefix)[1];
}

export function IdToIRI(id: string): string {
  return 'http://nowords.com#' + id;
}
